export default "__VITE_ASSET__zazKK9y5__"